import styled, { CreateStyled } from '@emotion/styled';
import { Theme } from '@material-ui/core';
import { IEMotionTheme } from './themes/emotionTheme';
export default styled as CreateStyled<Theme & IEMotionTheme>;
